/**
 * Parse a timestamp that may lack a timezone designator. The fuel-report
 * backend emits naive UTC ISO strings (e.g. `2026-07-03T08:00:00`, no `Z`),
 * which JavaScript's `Date` would read as *local* time — showing the raw UTC
 * value. Treat a timezone-less value as UTC so it renders in the viewer's zone.
 */
export function parseUtcIso(iso: string | null | undefined): Date {
  if (!iso) return new Date(NaN)
  const hasTz = /[zZ]$|[+-]\d{2}:?\d{2}$/.test(iso)
  return new Date(hasTz ? iso : `${iso}Z`)
}
